<template>
	<form class="form-horizontal" @submit.prevent="save">
		<div class="animated fadeIn">
			<b-card>
				<div class="display-table full-width mb-2">
					<strong class="card-title">{{$route.meta.label}}</strong>
				</div>
				<b-row>
					<ResponseAlert ref="response" />
					<b-col sm="6" class="mb-2">
						<b-form-group v-bind:class="{ 'is-invalid': errors.has('NIK')}" label="NIK">
							<b-form-input type="number" v-model="models.nik" v-validate="'required'" data-vv-name="NIK">
							</b-form-input>
							<div v-if="errors.has('NIK')">
								<p class="text-danger">{{ errors.first('NIK') }}</p>
							</div>
						</b-form-group>
						<b-form-group v-bind:class="{ 'is-invalid': errors.has('Nama')}" label="Nama">
							<b-form-input v-model="models.nama" v-validate="'required'" data-vv-name="nama">
							</b-form-input>
							<div v-if="errors.has('nama')">
								<p class="text-danger">{{ errors.first('nama') }}</p>
							</div>
						</b-form-group>

						<b-form-group v-bind:class="{ 'is-invalid': errors.has('role')}" label="Role">
							<select v-model="models.roleId" v-validate="'required'" data-vv-name="role"
								class="form-control">
								<option value="">Pilih Role</option>
								<option v-for="(v,i) in masters.roles" :value="v.id" :key="i">
									{{v.roleName}}
								</option>
							</select>
							<div v-if="errors.has('role')">
								<p class="text-danger">{{ errors.first('role') }}</p>
							</div>
						</b-form-group>

						<b-form-group v-bind:class="{ 'is-invalid': errors.has('Telepon')}" label="Telepon">
							<b-form-input  type="number" v-model="models.telepon" v-validate="'required'"
								data-vv-name="Telepon"></b-form-input>
							<div v-if="errors.has('Telepon')">
								<p class="text-danger">{{ errors.first('Telepon') }}</p>
							</div>
						</b-form-group>
					</b-col>
					<b-col sm="6" class="mb-2">

						<b-form-group label="Tanggal Lahir">
							<input type="hidden" v-model="models.tglLahir" v-validate="'required'" data-vv-name="Tanggal Lahir"/>
							<date-picker input-class="form-control" 
								v-model="models.tglLahir" 
								:editable="false" 
								:clearable="false" 
								format="YYYY-MM-DD" 
								:disabled-date="disabledDate"
								valueType="format"></date-picker>
							<div v-if="errors.has('Tanggal Lahir')">
								<p class="text-danger">{{ errors.first('Tanggal Lahir') }}</p>
							</div>
						</b-form-group>
						<b-form-group label="Address">
							<textarea class="form-control" v-model="models.address" rows="3"></textarea>
						</b-form-group>
						<b-form-group v-bind:class="{ 'is-invalid': errors.has('email')}" label="Email">
							<b-form-input type="email" v-model="models.email" v-validate="'required|email'"
								data-vv-name="email"></b-form-input>
							<div v-if="errors.has('email')">
								<p class="text-danger">{{ errors.first('email') }}</p>
							</div>
						</b-form-group>
						<b-form-group v-bind:class="{ 'is-invalid': errors.has('password')}" label="Password">
							<b-form-input type="password" v-model="models.password" v-validate="vars.role_password"
								data-vv-name="password"></b-form-input>
							<div v-if="errors.has('password')">
								<p class="text-danger">{{ errors.first('password') }}</p>
							</div>
						</b-form-group>
					</b-col>
				</b-row>
				<template #footer>
					<b-button type="submit" variant="primary" class="btn-min-width float-right">
						Simpan
					</b-button>
					<b-button type="button" variant="light" class="btn-min-width float-right" @click="$router.go(-1)">
						Kembali
					</b-button>
				</template>
			</b-card>
		</div>
	</form>
</template>
<script>
	import ResponseAlert from '@/components/response_alert';
	import DatePicker from 'vue2-datepicker';
  	import 'vue2-datepicker/index.css';
	import moment from 'moment';

	export default {
		name: 'FormUser',
		components: {
			ResponseAlert,
			DatePicker,
		},
		data() {
			return {
				config: {
					uri: this.$route.meta.permission.link,
				},
				models: {
					nama: "",
					tglLahir: moment().format('YYYY-MM-DD'),
					nik: "",
					telepon: "",
					password: "",
					email: "",
					urlPhoto: "",
					address: "",
					createdBy: "",
					roleId: ""
				},
				masters: {
					roles: [],
				},
				vars: {
					role_password: 'required|min:8'
				}
			}
		},
		created() {
			let _ = this
			_.getById();
			_.getRoles();
		},
		methods: {
			disabledDate: function (date) {
				return date > moment();
			},
			getById() {
				const _ = this;
				if (_.$route.params.id) {
					_.vars.role_password = ''
					_.$axios.get(`User/${_.$route.params.id}`)
						.then(res => {
							const { data } = res.data;
							_.models.nik = data.nik;
							_.models.nama = data.nama;
							_.models.tglLahir = moment(data.tanggalLahir).format('YYYY-MM-DD');
							_.models.telepon = data.telepon;
							_.models.email = data.email;
							_.models.address = data.address;
							_.models.telepon = data.telepon;
							_.models.roleId = data.userRoles.length ? data.userRoles[0].roleId : "";
							_.models.createdBy = data.createdBy;
						}).catch((err) => console.log(err));
				}
			},
			getRoles() {
				const _ = this
				_.$axios.get('Role')
				.then(res => _.masters.roles = res.data.data);
			},
			save() {
				const _ = this;
				const user = JSON.parse(localStorage.getItem('user'));
				_.$validator.validate().then(valid => {
					if (valid) {
						let request = "";
						if (!_.$route.params.id) {
							_.models.createdBy = user.name;
							request = _.$axios.post(`User`, _.models);
						} else {
							_.models.id = _.$route.params.id;
							_.models.modifiedBy = user.name;
							request = _.$axios.put(`User/${_.$route.params.id}`, _.models);
						}
						request
							.then(() => _.$router.push({
								name: _.config.uri
							}))
							.catch(error => _.$refs.response.setResponse(error.response.data.message, 'danger'));
					} else {
						window.scrollTo(0, 0);
					}
				});
			}
		}
	}
</script>